import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import { Page,
         Card,
         Box,
         Text,
         Layout,
         TextField,
         Button,
         Icon,
         BlockStack,
         Select,
         Checkbox,
         Divider,
         IndexTable,
         useIndexResourceState,
         useBreakpoints,
         Popover,
         RadioButton
       } from '@shopify/polaris';
import { SearchIcon, FilterIcon } from '@shopify/polaris-icons';

import { useAppBridge } from '@shopify/app-bridge-react';

import SkuLine from "./SkuLine";
import ConfirmGenerationDialog from './ConfirmGenerationDialog';
import GeneratingBarcodesNotice from './GeneratingBarcodesNotice';
import FeatureCard from '../partials/FeatureCard';
import LoadingSpinner from '../partials/LoadingSpinner';
import PageFooter from '../partials/PageFooter';
import NoLabelTemplatesBox from '../partials/NoLabelTemplatesBox';
import LoadingPlaceholder from '../partials/LoadingPlaceholder';
import RequiresRefreshBanner from '../partials/RequiresRefreshBanner';

import { updateSelectedItems, updateSelectedProducts, searchProducts } from '../../redux/actions/products';
import { refreshBatches } from '../../redux/actions/barcodes';
import { getSettings } from '../../redux/actions/settings';
import { locationsIndex } from '../../redux/actions/locations';

import { indexBarcodeTemplates } from '../../redux/actions/barcodeTemplates';

const ManageBarcodes = ({ shopUrl,
                          payload,
                          getTemplates,
                          generateActions,
                          downloadUrl,
                          barcodeTemplates,
                          submitSearch,
                          setSelectedVariantList,
                          isSearching,
                          searchedProducts,
                          selectedVariantList,
                          selectedProductCount,
                          searchedBarcodes,
                          productSelections,
                          setProductSelectionList,
                          batchRefresh,
                          settings,
                          settingsLoad,
                          searchEndCursor,
                          searchStartCursor,
                          searchHasNextPage,
                          searchHasPreviousPage,
                          locations,
                          loadLocations,
                          requiresRefresh
                          }) => {
  
  const shopify = useAppBridge();
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [missingBarcodeCount, setMissingBarcodeCount] = useState(0);

  const [inStockFilter, setInStockFilter] = useState(false);
  const [productTypeFilter, setProductTypeFilter] = useState(false);
  const [vendorFilter, setVendorFilter] = useState();
  const [generating, setGenerating] = useState(false);

  const [enqueueSearch, setEnqueueSearch] = useState(null);
  const [downloadSubmitted, setDownloadSubmitted] = useState(false);

  const [selectedLocation, setSelectedLocation] = useState('any');

  useEffect(() => {
    loadLocations(shopUrl, payload);
    settingsLoad(shopUrl, payload);
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if(searchTerm !== ''){
        console.log(searchTerm);

        handleSearch(searchTerm);
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchTerm, 500]);

  useEffect(() => {
    if(downloadUrl && downloadSubmitted) {
      let win = window.open(downloadUrl, '_blank');
      win.focus();
      setDownloadSubmitted(false);
    }
  }, [downloadUrl]);

  const handleSearch = (searchTerm) => {
    if(searchTerm !== ''){
      if(!isSearching) {
        setEnqueueSearch(null);
        submitSearch(shopUrl, payload, searchTerm, inStockFilter, productTypeFilter, vendorFilter, 'next', null, null);
      } else {
        setEnqueueSearch(searchTerm);
      }
    }
  }

  const searchNext = () => {
    if(!isSearching) {
      setEnqueueSearch(null);
      submitSearch(shopUrl, payload, searchTerm, inStockFilter, productTypeFilter, vendorFilter, 'next', searchEndCursor, searchStartCursor);
    }
  }

  const searchPrevious = () => {
    if(!isSearching) {
      setEnqueueSearch(null);
      submitSearch(shopUrl, payload, searchTerm, inStockFilter, productTypeFilter, vendorFilter, 'previous', searchEndCursor, searchStartCursor);
    }
  }

  useEffect(() => {
    handleSearch(searchTerm);
  }, [inStockFilter]);

  useEffect(() => {
    handleSearch(searchTerm);
  }, [productTypeFilter]);

  useEffect(() => {
    handleSearch(searchTerm);
  }, [vendorFilter]);

  useEffect(() => {
    if(!isSearching) {
      readySearch();
    }
  }, [isSearching]);

  useEffect(() => {
    if(generateActions.length > 0){
      setGenerating(false);
      const timeoutId = setTimeout(() => {
        if(generateActions.length > 0){
          batchRefresh(shopUrl, payload);
        }
      }, 3000);
      return () => clearTimeout(timeoutId);

    }

    if(generateActions.length === 0 && searchTerm !== '') {
      handleSearch(searchTerm);
    }
  }, [generateActions]);

  const readySearch = () => {
    if(enqueueSearch) {
      submitSearch(shopUrl, payload, searchTerm, inStockFilter, productTypeFilter, vendorFilter, 'next', null, null);
      setEnqueueSearch(null);
    }
  }

  useEffect(() => {
    countMissingBarcodes();
  }, [selectedVariantList]);

  const validateTerm = (event) => {
    setSearchTerm(event);
  }

  const toggleFilters = (event) => {
    setShowFilters(!showFilters);
  }

  const toggleInStock = () => {
    setInStockFilter(!inStockFilter);
  }

  const handleVendorSelect = (event) => {
    setVendorFilter(event);
  }

  const clearCategory = () => {
    setCategoryFilter('');
  }

  const countMissingBarcodes = () => {
    // setMissingBarcodeCount()
  }

  const toggleChecked = (selection) => {
    let item = searchedProducts.find((searched) => searched.id === selection);
    if (item.type === 'product') {
      toggleProduct(item.id);
    }

    if (item.type === 'variant') {
      let relatedProduct = searchedProducts.find((product) => product.id === item.parent);

      toggleVariant({
        id: item.id,
        parent: item.parent,
        sku: item.sku,
        barcode: item.barcode,
        featuredMedia: item.featuredMedia,
        name: relatedProduct.title,
        options: item.selectedOptions,
        price: item.price,
        quantity: item.inventoryQuantity || item.totalInventory
      });
    }
  }

  const toggleProduct = (lineId) => {
    let relatedProduct = searchedProducts.find((product) => product.id === lineId);
    let idList = selectedVariantList.map((variant) => variant.id);

    let relatedVariants = []

    relatedProduct.variants.forEach((variant) => {
      relatedVariants.push({
        id: variant.id,
        parent: variant.parent,
        sku: variant.sku,
        barcode: variant.barcode,
        featuredMedia: relatedProduct.featuredMedia,
        name: relatedProduct.title,
        options: variant.selectedOptions,
        price: variant.price,
        quantity: variant.inventoryQuantity || variant.totalInventory
      })
    })

    let unselectedVariants = relatedVariants.filter(variant => !idList.includes(variant.id));
    let selectedVariants = relatedVariants.filter(variant => idList.includes(variant.id));
    let newProductSelections = {...productSelections}

    if(unselectedVariants.length === 0) {
      disableVariants(selectedVariants);
      newProductSelections[relatedProduct.id] = false;
    } else {
      enableVariants(unselectedVariants);
      newProductSelections[relatedProduct.id] = true;
    }

    setProductSelectionList(newProductSelections);
  }

  const toggleVariant = (variant) => {
    let relatedProduct = searchedProducts.find((product) => product.id === variant.parent);
    let idList = selectedVariantList.map((variant) => variant.id);

    variant.featuredMedia = relatedProduct.featuredMedia;

    if(idList.indexOf(variant.id) > -1) {
      let index = idList.indexOf(variant.id);
      selectedVariantList.splice(index, 1);
      setSelectedVariantList([...selectedVariantList], relatedProduct);
    } else {
      setSelectedVariantList([...selectedVariantList, variant], relatedProduct);
    }
  }

  const enableVariants = (variants) => {
    setSelectedVariantList([...selectedVariantList, ...variants], null)
  }

  const disableVariants = (variants) => {
    let newVariants = [...selectedVariantList];
    let index = null;
    let removalList = variants.map((variant) => variant.id);

    removalList.forEach((variantId) => { 
      newVariants[newVariants.findIndex((variant) => variant?.id === variantId)] = null;
    });

    newVariants = newVariants.filter(n => n);

    setSelectedVariantList(newVariants, null);
  }

  const selectAllSearched = () => {
    let newProductSelections = {...productSelections}
    let unselectedVariants = [];
    let idList = selectedVariantList.map((variant) => variant.id);

    searchedProducts.forEach((product) => {
      if(product.type === 'variant') { return; }
      product.variants.filter(variant => !idList.includes(variant.id)).forEach((variant) => {
        unselectedVariants.push({
          id: variant.id,
          parent: variant.parent,
          sku: variant.sku,
          barcode: variant.barcode,
          featuredMedia: product.featuredMedia,
          name: product.title,
          options: variant.selectedOptions,
          price: variant.price,
          quantity: variant.inventoryQuantity || variant.totalInventory
        })
      });

      newProductSelections[product.id] = true;
    });

    if(unselectedVariants.length > 0) { enableVariants(unselectedVariants); }
    setProductSelectionList(newProductSelections);
  }

  const deselectAllSelected = () => {
    setSelectedVariantList([], null);
    setProductSelectionList({});
  }

  const promotedBulkActions = [
    {
      content: 'Generate Barcode Images',
      onAction: () => shopify.modal.show('generate-modal'),
      disabled: generating,
    },
    {
      content: 'Print Labels',
      onAction: () => navigate(`/print${window.location.search}`),
    }
  ];

  const bulkActions = [];

  const {selectedResources, allResourcesSelected, handleSelectionChange, clearSelection} = useIndexResourceState(searchedProducts);

  const handleSelection = (selectionType, toggleType, selection, position) => {
    if(selectionType === 'page' && toggleType) { selectAllSearched(); }
    if(selectionType === 'page' && !toggleType) { deselectAllSelected(); }

    if(selectionType === 'single') { toggleChecked(selection); }
  }

  const handleLocationSwitch = (event) => {
    setSelectedLocation(event);
  }

  const resourceName = {
    singular: 'item',
    plural: 'items',
  };

  const rowMarkup = searchedProducts?.map(
    (
      {
        id,
        category,
        featuredMedia,
        producType,
        status,
        tags,
        title,
        totalInventory,
        tracksInventory,
        type,
        variants,
        vendor,
        barcode,
        inventoryQuantity,
        displayName,
        parent,
        price,
        selectedOptions,
        sku,
        available_locations,
        inventory_levels
      },
      index,
    ) => (
     <SkuLine
        key={id}
        shopUrl={shopUrl}
        payload={payload}
        setDownloadSubmitted={setDownloadSubmitted}
        selectedVariantList={selectedVariantList}
        index={index}
        id={id}
        category={category}
        featuredMedia={featuredMedia}
        producType={producType}
        status={status}
        tags={tags}
        title={title}
        totalInventory={totalInventory}
        tracksInventory={tracksInventory}
        type={type}
        variants={variants}
        vendor={vendor}
        barcode={barcode}
        inventoryQuantity={inventoryQuantity}
        displayName={displayName}
        parent={parent}
        price={price}
        selectedOptions={selectedOptions}
        sku={sku}
        toggleProduct={toggleProduct}
        toggleVariant={toggleVariant}
        productSelections={productSelections}
        availableLocations={available_locations}
        selectedLocation={selectedLocation}
        inventoryLevels={inventory_levels}
      />
    )
  )

  const filterActivator = (
    <Button icon={FilterIcon} onClick={toggleFilters} disclosure>
      Filters
    </Button>
  );

  
  return (
    <Page
      fullWidth
      title="Labels + Print"
      backAction={{content: 'Back', url: 'https://' + window.location.hostname + window.location.search}}
      primaryAction={
        <>
          { locations.status === 'success' &&
            <Popover
              active={showFilters}
              activator={filterActivator}
              autofocusTarget="first-node"
              onClose={toggleFilters}
            >
              <Popover.Pane fixed>
                <Popover.Section>
                  <Checkbox
                    label="In Stock"
                    checked={inStockFilter}
                    onChange={toggleInStock}
                  />
                  <Divider />
                  <BlockStack gap="100">
                    <RadioButton
                      label="Any location"
                      checked={selectedLocation === 'any'}
                      id="any"
                      name="location"
                      onChange={() => handleLocationSwitch('any')}
                    />
                    { locations.locations.map(location =>
                        <RadioButton
                          key={location.id}
                          label={location.name}
                          checked={selectedLocation === location.id}
                          id={location.id}
                          name="location"
                          onChange={() => handleLocationSwitch(location.id)}
                        />
                      )
                    }
                  </BlockStack>
                </Popover.Section>
              </Popover.Pane>
            </Popover>
          }
          { locations.status !== 'success' &&
            <LoadingSpinner size="small" />
          }
        </>
      }
    >
      { requiresRefresh &&
        <RequiresRefreshBanner />
      }
      <BlockStack gap="500">
        <Layout>
          <Layout.Section>
            <Card>
              <Box paddingBlockStart="200">
                <TextField
                  label="Catalog Search"
                  value={searchTerm}
                  onChange={validateTerm}
                  autoComplete="off"
                  placeholder="Search"
                  prefix={<Icon source={SearchIcon} />}
                />
              </Box>
            </Card>
          </Layout.Section>
        </Layout>
        <Layout>
          <Layout.Section>
            <Card>
              { generateActions.map(notice =>
                <GeneratingBarcodesNotice 
                  notice={notice}
                  key={notice.action_id}
                />
              )}

              <IndexTable
                condensed={useBreakpoints().smDown}
                resourceName={resourceName}
                itemCount={searchedProducts?.filter(line => line.type === 'variant')?.length || 0}
                selectedItemsCount={ selectedVariantList?.length || 0 }
                headings={[
                  {title: 'Image'},
                  {title: 'Name'},
                  {title: 'Inventory', alignment: 'end'},
                  {title: 'Tags / Options'},
                  {title: 'Actions'}
                ]}
                bulkActions={bulkActions}
                promotedBulkActions={promotedBulkActions}
                loading={isSearching}
                onSelectionChange={handleSelection}
                pagination={{
                  hasPrevious: searchHasPreviousPage && !isSearching,
                  hasNext: searchHasNextPage && !isSearching,
                  onNext: () => {searchNext()},
                  onPrevious: () => {searchPrevious()},
                }}

              >
                {rowMarkup}
              </IndexTable>
            </Card>
          </Layout.Section>
        </Layout>
        <PageFooter stripeBackground='#1774bb' helpLink="inventory-management/manage-barcode-label-templates-3/" helpDescription="generating and using barcode images" />
      </BlockStack>

      <ConfirmGenerationDialog
        shopify={shopify}
        shopUrl={shopUrl}
        payload={payload}
        setGenerating={setGenerating}
      />
    </Page>
  )
}

const mapStateToProps = state => ({
  requiresRefresh: state.activeToken.requiresRefresh,
  locations: state.locations,
  generateActions: state.barcodes.generateActions,
  downloadUrl: state.barcodes.downloadUrl,
  barcodeTemplates: state.barcodeTemplates,
  isSearching: state.products.isFetching,
  searchedProducts: state.products.searchedProducts,
  selectedVariantList: state.products.selectedVariantList,
  productSelections: state.products.productSelections,
  searchedBarcodes: state.products.searchedBarcodes,
  settings: state.settings,
  searchEndCursor: state.products.searchEndCursor,
  searchStartCursor: state.products.searchStartCursor,
  searchHasNextPage: state.products.searchHasNextPage,
  searchHasPreviousPage: state.products.searchHasPreviousPage,
});

const mapDispatchToProps = (dispatch) => ({
  loadLocations: (shopUrl, payload) => dispatch(locationsIndex(shopUrl, payload)),
  getTemplates: (shopUrl, payload) => dispatch(indexBarcodeTemplates(shopUrl, payload)),
  batchRefresh: (shopUrl, payload) => dispatch(refreshBatches(shopUrl, payload)),
  submitSearch: (shopUrl, payload, searchTerm, inStockFilter, productTypeFilter, vendorFilter, direction, endCursor, startCursor) => dispatch(searchProducts(shopUrl, payload, searchTerm, inStockFilter, productTypeFilter, vendorFilter, direction, endCursor, startCursor)),
  setSelectedVariantList: (items, relatedProduct) => dispatch(updateSelectedItems(items, relatedProduct)),
  setProductSelectionList: (products) => dispatch(updateSelectedProducts(products)),
  settingsLoad: (storeUrl, payload) => dispatch(getSettings(storeUrl, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageBarcodes);
